module.exports = __webpack_public_path__ + "static/media/fabricio-norat.9f7bc723.png";